// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folded:not(.unfolded) :host .nav-link>.nav-link-title,.folded:not(.unfolded) :host .nav-link>.nav-link-badge{opacity:0;transition:opacity 200ms ease}", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();